import { PopupsAction, PopupsActionTypes, PopupsState } from 'ui/types/popups';

const initialState: PopupsState = {};

export const popupsReducer = (state: PopupsState = initialState, action: PopupsAction): PopupsState => {
  switch (action.type) {
    case PopupsActionTypes.OPEN_POPUP: {
      const { id, data } = action.payload;
      return {
        ...state,
        [id]: { isOpen: true, data }
      };
    }
    case PopupsActionTypes.CLOSE_POPUP: {
      const { id } = action.payload;
      return {
        ...state,
        [id]: { isOpen: false, data: undefined }
      };
    }
    default:
      return state;
  }
};


